module.exports = class {
  constructor() {
    this.containerElement = document.querySelector('body');
    this.isRunning = false;
  }

  start() {
    if (this.isRunning) {
      return;
    }
    this.isRunning = true;

    if (!this.containerElement.querySelectorAll('.loading-overlay').length) {
      this.loadingOverlayElement = document.createElement('div');
      this.loadingOverlayElement.className = 'loading-overlay';

      this.spinnerElement = document.createElement('div');
      this.spinnerElement.className = 'loading-overlay-spinner icon-g-loader';

      this.loadingOverlayElement.appendChild(this.spinnerElement);
      this.containerElement.appendChild(this.loadingOverlayElement);
    }

    this.loadingOverlayElement.style.display = null;
  }

  stop() {
    if (!this.isRunning) {
      return;
    }
    this.isRunning = false;

    this.loadingOverlayElement.style.display = 'none';
  }
};
